import React from "react";
import { Link } from "react-router-dom";
import { Card, CardBody, Pagination, PaginationItem, PaginationLink } from "reactstrap";

export interface ActivityItem {
  date: string;
  text: string;
  listingId?: string | null;
  userId?: string | null;
  bidId?: string | null;
}

const DEFAULT_ITEMS: ActivityItem[] = [
  { date: "—", text: "No recent activity." },
];

interface RecentActivityProps {
  items?: ActivityItem[];
  totalCount?: number;
  page?: number;
  limit?: number;
  onPageChange?: (page: number) => void;
}

const RecentActivity = (props: RecentActivityProps) => {
  const items = props.items?.length ? props.items : DEFAULT_ITEMS;
  const totalCount = props.totalCount ?? 0;
  const page = props.page ?? 1;
  const limit = props.limit ?? 10;
  const onPageChange = props.onPageChange;
  const totalPages = Math.max(1, Math.ceil(totalCount / limit));
  const showPagination = totalCount > limit && onPageChange;

  return (
    <Card>
      <CardBody>
        <h4 className="card-title mb-4">Recent Activity Feed</h4>
        <ol className="activity-feed mb-0">
          {items.map((item, key) => (
            <li className="feed-item" key={key}>
              <div className="feed-item-list">
                <span className="date">{item.date}</span>
                {item.listingId ? (
                  <Link to={`/property/${item.listingId}`} className="activity-text text-primary">
                    {item.text}
                  </Link>
                ) : (
                  <span className="activity-text">{item.text}</span>
                )}
              </div>
            </li>
          ))}
        </ol>
        {showPagination && (
          <div className="d-flex justify-content-between align-items-center mt-3 flex-wrap gap-2">
            <small className="text-muted">
              Showing {(page - 1) * limit + 1}–{Math.min(page * limit, totalCount)} of {totalCount}
            </small>
            <Pagination className="mb-0 pagination-sm">
              <PaginationItem disabled={page <= 1}>
                <PaginationLink previous onClick={() => page > 1 && onPageChange(page - 1)} />
              </PaginationItem>
              {Array.from({ length: totalPages }, (_, i) => i + 1)
                .filter((p) => p === 1 || p === totalPages || (p >= page - 2 && p <= page + 2))
                .map((p, i, arr) => (
                  <React.Fragment key={p}>
                    {i > 0 && arr[i - 1] !== p - 1 && (
                      <PaginationItem disabled>
                        <PaginationLink>…</PaginationLink>
                      </PaginationItem>
                    )}
                    <PaginationItem active={p === page}>
                      <PaginationLink onClick={() => onPageChange(p)}>{p}</PaginationLink>
                    </PaginationItem>
                  </React.Fragment>
                ))}
              <PaginationItem disabled={page >= totalPages}>
                <PaginationLink next onClick={() => page < totalPages && onPageChange(page + 1)} />
              </PaginationItem>
            </Pagination>
          </div>
        )}
      </CardBody>
    </Card>
  );
};

export default RecentActivity;
